<template>
    <FiltroLateral
        :isLoading="isLoading"
        :showFilter="showFilter"
        :filterCompact="filterCompact"
        @closeFilter="closeFilter"
        @onClearFilters="onClearFilters"
        @searchTable="searchTable"
    >
        <div class="card-content">
            <div class="columns is-multiline card-content-section">
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(1)"
                        :value="grupoSelected"
                        title="produto-grupo-produto"
                        :options="grupoSelect"
                        :loading="grupoLoading"
                        @input="updateGrupo"
                        @search="carregarGrupos"
                        multiple
                        searchable
                        clearable
                        :disabled="grupoSelect.length == 0"
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(2)"
                        :value="subgrupoSelected"
                        title="produto-subgrupo-produto"
                        :options="subgrupoSelect"
                        :loading="subgrupoLoading"
                        @input="updateSubGrupo"
                        @search="carregarSubGrupos"
                        multiple
                        searchable
                        clearable
                        :disabled="grupoSelect.length == 0"
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(3)"
                        title="produto-linhaproduto"
                        :value="linhaSelected"
                        :options="linhaSelect"
                        :loading="linhaLoading"
                        @input="updateLinhas"
                        @search="carregarLinhas"
                        multiple
                        searchable
                        clearable
                        :disabled="subgrupoSelect.length == 0"
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(4)"
                        :value="fornecedorSelected"
                        title="fornecedor-produto"
                        :options="fornecedorSelect"
                        :loading="fornecedorLoading"
                        @input="updateFornecedor"
                        @search="carregarFornecedores"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <v-input
                        :id="generateId(7)"
                        :value="referenciaProduto"
                        @input="updateReferencia"
                        :maxlength="100"
                        :title="'referencia-produto'"
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <v-input
                        :id="generateId(8)"
                        :value="complementoProduto"
                        @input="updateComplemento"
                        :maxlength="255"
                        :title="'complemento-produto'"
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(5)"
                        title="catalogo"
                        :value="catalogoTipoSelected"
                        :options="catalogoTipoOption"
                        mlLabels
                        @input="updateCatalogoTipo"
                        tooltipLabel="informacao-tipo-catalogo"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(6)"
                        title="tab-preco"
                        :value="tabelaPrecoTipoSelected"
                        :options="tabelaPrecoTipoOption"
                        mlLabels
                        @input="updateTabelaPrecoTipo"
                        tooltipLabel="tooltip-ass-tab-preco-produto-filtro"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(9)"
                        title="bonificacao"
                        :value="bonificacaoSelected"
                        @input="updateBonif"
                        :options="bonificacaoOption"
                        tooltipLabel="tooltip-permite-bonif"
                        mlLabels
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(10)"
                        title="promocao"
                        :value="promocaoSelected" 
                        @input="updatePromo" 
                        :options="promocaoOption"
                        tooltipLabel="tooltip-promocao"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                        mlLabels
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(11)"
                        :value="kitComboSelected"
                        @input="updateKitCombo"
                        title="kit-combo"
                        :options="kitComboOption"
                        tooltipLabel="tooltip-apenas-kitcombo"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                        mlLabels
                    />
                </div>
                <!-- @86351 - Permitir o usuário inativar a visualização de fotos.
                    Se ativar, tera uma altura melhor na tela de listagem,
                    permitindo assim mais registros por pagina -->
                <div class="column is-6 is-full-mobile card-content-top">
                    <vss-select
                        :id="generateId(13)"
                        v-model="situacaoSelected"
                        title="situacao"
                        @input="updateSituacao"
                        :options="situacaoOption"
                        tooltipLabel="tooltip-produtos-inativos"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                        mlLabels
                    />
                </div>
                <div class="column is-6 is-full-mobile card-content-top">
                    <div class="switchClass">
                        <div>
                            <label>{{ $t('mostrar-fotos') }}</label>
                            <b-tooltip 
                                type="is-dark"
                                multilined
                                :label="$t('tooltip-visualizar-fotos')"
                                class="ml-1 tooltip-label"
                            >
                            <b-icon icon="information" size="is-small"/>
                            </b-tooltip>
                        </div>
                        <b-switch
                            :id="generateId(12)"
                            v-model="mostrarFotos" 
                            :title="mostrarFotos ? $t('sim') : $t('nao')"
                        >
                            <span v-if="mostrarFotos">{{ $t('sim') }}</span>
                            <span v-else>{{ $t('nao') }}</span>
                        </b-switch>
                    </div>
                </div>
                </div>
            </div>
    </FiltroLateral>
</template>

<script>
import GrupoProdutoService from '@/services/GrupoProdutoService';
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService';
import LinhaProdutoService from '@/services/LinhaProdutoService';
import FornecedorService from '@/services/vendas/FornecedorService';
import FiltroLateral from '@/components/shared/FiltroLateral';

export default {
    components: {
        FiltroLateral,
    },
    props: {
        empresa: {
            type: Object,
            default: {},
        },
        showFilter: {
			type: Boolean,
			default: false,
		},
        filtroMostrarFotos: {
			type: Boolean,
			default: true,
		},
        isLoading: {
			type: Boolean,
			default: false,
		}
	},
	watch: {

        /*  @89816 - Caso uma tabela de precos seja selecionada, o filtro tipo de tabela de precos deve ser atualizado.*/
        isTabPrecoSelected(newValue) {
            if (newValue) {
                this.tabelaPrecoTipoSelected = this.tabelaPrecoTipoOption[1];

                this.$emit("update-filtro", {
                    nomeFiltro: "tabelaPreco",
                    valor: this.tabelaPrecoTipoOption[1].value
                });
                this.searchTable(false);
            } else {
                this.tabelaPrecoTipoSelected = this.tabelaPrecoTipoOption[0];

                this.$emit("update-filtro", {
                    nomeFiltro: "tabelaPreco",
                    valor: null,
                });
                this.searchTable(false);
            }
        },
		empresa :{
			deep: true,
			handler: function() {
				this.grupoSelected = [];
				this.carregarGrupos("");
			}
		},
	},
	data() {
		return {
			sort: {
				order: 'desc',
				column: 'DESCRICAO'
			},
			filtroIsOpen: false,

            catalogoTipoOption: [
                {value: 2, label: "todos"},
                {value: 1, label: "com-imagens"},
                {value: 0, label: "sem-imagens"}
            ],
            tabelaPrecoTipoOption: [
                {value: 2, label: "todos"},
                {value: 1, label: "com-tabela-de-preco"},
                {value: 0, label: "semtabelapreco"}
            ],
            bonificacaoOption: [
                {value: 2, label: 'todos'},
                {value: 1, label: 'possuem-bonificacao'},
                {value: 0, label: 'nao-possuem-bonificacao'}
            ],
            promocaoOption: [
                {value: 2, label: 'todos'},
                {value: 1, label: 'com-promocao'},
                {value: 0, label: 'sem-promocao'}
            ],
            kitComboOption: [
                {value: 2, label: 'todos'},
                {value: 1, label: 'apenas-kitcombo'},
                {value: 0, label: 'sem-kit-combo'}
            ],
            fotoOption: [
                {value: 2, label: 'todos'},
                {value: 1, label: 'exibe-fotos'},
                {value: 0, label: 'oculta-fotos'}
            ],
            situacaoOption: [
                {value: 2, label: 'todos'},
                {value: 1, label: 'ativos'},
                {value: 0, label: 'inativos'}
            ],
            catalogoTipoSelected: {value: 2, label: "todos"},
            tabelaPrecoTipoSelected: {value: 2, label: "todos"},
      		bonificacaoSelected: {value: 2, label: "todos"},
      		promocaoSelected: {value: 2, label: "todos"},
      		kitComboSelected: {value: 2, label: "todos"},
            situacaoSelected: {value: 2, label: "todos"},
            mostrarFotos: true,
            filterCompact: false,
			gruposervice: new GrupoProdutoService(this.$http, this.$router),
			grupoLoading: false,
			grupoSelect: [],
			grupoSelected: [],
			debouncedSearchGrupo: null,
			
			subgruposervice: new SubGrupoProdutoService(this.$http, this.$router),
			subgrupoLoading: false,
			subgrupoSelect: [],
			subgrupoSelected: [],
			debouncedSearchSubGrupo: null,

            linhaservice: new LinhaProdutoService(this.$http, this.$router),
            linhaLoading: false,
            linhaSelect: [],
            linhaSelected: [],
            debouncedSearchLinha: null,

            fornecedorservice: new FornecedorService(this.$http, this.$router),
            fornecedorLoading: false,
            fornecedorSelect: [],
            fornecedorSelected: [],
            debouncedSearchFornecedor: null,

			referenciaProduto: '',
			complementoProduto: '',
		};
	},
	created () {
        this.mostrarFotos = this.filtroMostrarFotos;

		this.debouncedSearchGrupo = this.debounce(this.onSearchGrupo, 500);
		this.debouncedSearchSubGrupo = this.debounce(this.onSearchSubgrupo, 500);
		this.debouncedSearchLinha = this.debounce(this.onSearchLinha, 500);
		this.debouncedSearchFornecedor = this.debounce(this.onSearchFornecedor, 500);
        this.carregarFornecedores();
	},
	methods: {
        subgrupoList() {
            const selectedGrupo = this.grupoprodutoList.find((grupo) => grupo.idgrupoproduto === this.filters.grupoproduto);
            return selectedGrupo && selectedGrupo.subgrupoprodutolist ? selectedGrupo.subgrupoprodutolist : [];
        },
        closeFilter(filtro){
            this.$emit('showFilter', filtro);
        },
        onClearFilters(clear) {
			this.$root.confirm({
				message: this.$t("msg-confirm-limpar-filtros"),
				onConfirm:() => {
                    this.limparFiltrosSelecionados();
                    this.$emit('limparFiltros', clear);
                },
            });
        },
        searchTable(search) {
            if (this.$cookies.get('fotos-produto') != undefined) {
                this.$cookies.remove('fotos-produto');
            }
            this.updateMostrarFotos(this.mostrarFotos);
            this.$emit('pesquisar', search);
        },
        onSearchGrupo(value) {
            let query = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarGrupos(query);
        },
        onSearchSubgrupo(value) {
            let query = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarSubGrupos(query);
        },
        onSearchLinha(value) {
            let query = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarLinhas(query);
        },
        onSearchFornecedor(value) {
			let query = Util.removeToSearch(value);
			this.pagination.currentPage = 1;
			this.carregarFornecedores(query);
		},
		generateId(numberId){
			return this.$route.name + '-' + numberId;
		},
		openFiltro(){
			this.filtroIsOpen = true;
		},
		closeFiltro(){
			this.filtroIsOpen = false;
		},
		limparFiltrosSelecionados(){
			this.updateGrupo([]);
			this.updateSubGrupo([]);
			this.updateLinhas([]);
			this.updateFornecedor([]);
			this.updateReferencia("");
			this.updateComplemento("");
            this.updateBonif({value: 2, label: "todos"});
            this.updatePromo({value: 2, label: "todos"});
            this.updateKitCombo({value: 2, label: "todos"});
            this.updateSituacao({value: 2, label: "todos"});
            this.updateCatalogoTipo({value: 2, label: "todos"});
            this.updateTabelaPrecoTipo({value: 2, label: "todos"});
            this.updateMostrarFotos(true);
		},
        updateCatalogoTipo(catalogoTipoSelected) {
			this.catalogoTipoSelected = catalogoTipoSelected;

            this.$emit("update-filtro", {
				nomeFiltro: "catalogo",
				valor: catalogoTipoSelected.value
			});
		},
        updateTabelaPrecoTipo(tabelaPrecoTipoSelected) {
			this.tabelaPrecoTipoSelected = tabelaPrecoTipoSelected;

            this.$emit("update-filtro", {
				nomeFiltro: "tabelaPreco",
				valor: tabelaPrecoTipoSelected.value
			});
		},
		carregarGrupos(search = "") {
            this.grupoLoading = true;
            let empresas = "0"; 
            if (this.empresa && this.empresa.id) {
                empresas += `, ${this.empresa.id}`;
            }
            this.gruposervice
                .findAllComboWithEmpresa(empresas, search)
                .then(body => {
                    this.grupoSelect = [];
                    body.content.map((r) => {
                        let grupo = {
                            id: r.idgrupoproduto,
                            label: r.descricao,
                        };
                        this.grupoSelect.push(grupo);
                    });
                    this.grupoSelect.sort();
                }, 350)
                .catch(e => {
                    console.error(`Erro ao realizar pesquisa de grupo: ${e}`);
                })
                .finally(_ => {
                    this.grupoLoading = false;
                    if (this.grupoSelected.length > 0) {
                        this.carregarSubGrupos();
                    } else {
                        this.subgrupoSelect = [];
                    }
                });
        },
		updateGrupo(grupoSelected) {
            let tempGrupo = this.grupoSelected;
            this.grupoSelected = grupoSelected;
            if (this.grupoSelected.length === 0) {
                this.subgrupoSelect = [];
                this.updateSubGrupo([])
            } else if (tempGrupo > grupoSelected) {
                this.subgrupoSelect = [];
                this.updateSubGrupo([])
                this.carregarSubGrupos();
            } else {
                this.carregarSubGrupos();
            }
            this.$emit("update-filtro", {
                nomeFiltro: "grupos",
                valor: this.grupoSelected.length == 0 
                    ? [] : this.grupoSelected.map(e => e.id)
            });
        },
		carregarSubGrupos(search = "") {
            if (this.grupoSelected.length === 0) {
                this.subgrupoSelect = [];
                this.subgrupoSelected = [];
                return;
            }
            this.subgrupoLoading = true;
            this.subgrupoSelect = [];
            let grupos = this.grupoSelected.map(e => e.id).join(", ");
            this.subgruposervice
                .findAllCombo(0, 50, this.sort, grupos, 1, search)
                .then(body => {
                    body.content.map((r) => {
                        let subgrupo = {
                            id: r.idsubgrupoproduto,
                            label: r.descricao,
                        };
                        this.subgrupoSelect.push(subgrupo);
                    });
                    this.subgrupoSelect.sort();
                }, 350)
                .catch(e => {
                    console.error(`Erro ao realizar pesquisa de subgrupo: ${e}`);
                })
                .finally(_ => {
                    this.subgrupoLoading = false;
                    this.carregarLinhas();
                });
        },
        updateSubGrupo(subgrupoSelected) {
            this.subgrupoSelected = subgrupoSelected;
            this.carregarLinhas();
            this.$emit("update-filtro", {
                nomeFiltro: "subgrupos",
                valor: this.subgrupoSelected.length == 0 
                    ? [] : this.subgrupoSelected.map(e => e.id)
            });
        },
		carregarLinhas(search = "") {
			if(this.subgrupoSelect.length == 0 || this.subgrupoSelect == null){
				this.linhaSelect = [];
				this.updateLinhas([]);
				return;
			}
			this.linhaLoading = true;
			this.linhaSelect = [];
			let subgrupos = "";
			if(this.subgrupoSelected.length == 0){
				this.subgrupoSelect.forEach((e) => {
					subgrupos += `${e.id}, `;
				})
			} else {
				this.subgrupoSelected.forEach((e) => {
					subgrupos += `${e.id}, `;
				})
			}
			subgrupos = subgrupos.slice(0,-2);

            this.linhaservice
                .findAllCombo(this.sort.column, this.sort.order, 0, 20, subgrupos, 1, search)
                .then((body) => {
                    body.content.map((r) => {
                        let linha = {
                            id: r.idlinhaproduto,
                            label: r.descricao,
                        };
                        this.linhaSelect.push(linha);
                    });
                    this.linhaSelect.sort();
                }, 350)
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de linha:  ${e}`);
                })
                .finally((_) => {
                    this.linhaLoading = false;
                });
        },
        updateLinhas(linhaSelected) {
            this.linhaSelected = linhaSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'linhas',
                valor: this.linhaSelected.length == 0 ? [] : this.linhaSelected.map((e) => e.id),
            });
        },
        carregarFornecedores(search = '') {
            this.fornecedorLoading = true;
            this.fornecedorservice
                .findCombo(search)
                .then((body) => {
                    this.fornecedorSelect = [];
                    body.content.map((r) => {
                        let fornecedor = {
                            id: r.idfornecedor,
                            label: `${r.idfornecedorerp} - ${r.nome}`,
                        };
                        this.fornecedorSelect.push(fornecedor);
                    });
                    this.fornecedorSelect.sort();
                }, 350)
				.catch(e => {
					console.error( `Erro ao realizar pesquisa de fornecedor:  ${e}`);
				})
				.finally(_ => {
					this.fornecedorLoading = false;
				});
		},
		updateFornecedor(fornecedorSelected) {
			this.fornecedorSelected = fornecedorSelected;
			this.$emit("update-filtro", {
				nomeFiltro: "fornecedores",
				valor: this.fornecedorSelected.length == 0 
					? [] : this.fornecedorSelected.map(e => e.id)
			});
		},
		updateReferencia(value) {
			this.referenciaProduto = value;
			this.$emit("update-filtro", {
				nomeFiltro: "referencia",
				valor: this.referenciaProduto
			});
		},
		updateComplemento(value) {
			this.complementoProduto = value;
			this.$emit("update-filtro", {
				nomeFiltro: "complemento",
				valor: this.complementoProduto
			});
		},
		updateBonif(bonif) {
			this.bonificacaoSelected = bonif;
			this.$emit("update-filtro", {
				nomeFiltro: "bonificacao",
				valor: this.bonificacaoSelected.value
			});
		},
		updatePromo(promo) {
			this.promocaoSelected = promo;
			this.$emit("update-filtro", {
				nomeFiltro: "promocao",
				valor: this.promocaoSelected.value
			});
		},
		updateKitCombo(kitcombo) {
			this.kitComboSelected = kitcombo;
			this.$emit("update-filtro", {
				nomeFiltro: "kitCombo",
				valor: this.kitComboSelected.value
			});
		},
        updateSituacao(situacaoSelected) {
            this.situacaoSelected = situacaoSelected;
            this.$emit("update-filtro", {
                nomeFiltro: "situacao",
                valor: this.situacaoSelected.value
            });
        },
        updateMostrarFotos(mostrarFotos) {
            this.mostrarFotos = mostrarFotos;
            this.$emit('update-filtro', {
                nomeFiltro: 'mostrarFotos',
                valor: this.mostrarFotos,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.card-content {
    padding-top: 0px;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0.75rem;
    margin: 0px;
    .card-content-section {
        padding: 0px;
        margin-top: 0.75rem;
        margin-bottom: 0px;
        margin-left: 0px;
        margin-right: 0px;
    }
    .card-content-top {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        .switchClass {
            text-align: left;
        }
    }
}
</style>
